<template>
	<div class="editor">
		<title>{{data.title}}</title>
		<div v-html="data.config_value" style="margin:5px 10px;"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				data:'',
			}
		},
		mounted() {
			let self=this
			if(!self.$route.params.editorValue){
				this.$router.go(-1);
			}
			self.$store.dispatch('post',{u:'/rich_cext_config/get',d:{config_key:self.$route.params.editorValue}}).then(function(res){
		    	if(res.err==0){
		    		self.data=res.data
					return
		    	}
			})
		}
	}
</script>
<style scoped>
	p{
		text-align:justify;
	}
</style>
<style>
	.editor img{
		margin: 0 auto;
		max-width: 80%;
	}
</style>


// WEBPACK FOOTER //
// src/views/editor.vue